import { __rest } from "tslib";
import React from 'react';
import Menu from '../../../menu';
import { MainFrameContext } from '../../index';
const { SubMenu, Item } = Menu;
const Navigation = (props) => {
    const { data } = props, otherProps = __rest(props, ["data"]);
    const { prefixCls } = React.useContext(MainFrameContext);
    // 判断是否有子节点
    const isHaveChildren = (item) => {
        if (item && item.children && item.children.length > 0) {
            return true;
        }
        return false;
    };
    // 获取含子菜单的HTML
    const getSubMenuHTML = (item) => {
        var _a;
        const children = item.children;
        // 如果有子页（子路由），说明当前节点是菜单末级节点。
        const hasSubPage = children === null || children === void 0 ? void 0 : children.some((child) => { var _a; return ((_a = child === null || child === void 0 ? void 0 : child.data) === null || _a === void 0 ? void 0 : _a.type) === 'subpage'; });
        if (hasSubPage) {
            return getMenuItemHTML(item);
        }
        return (React.createElement(SubMenu, { key: `${item.key}`, icon: item.icon, title: (_a = item === null || item === void 0 ? void 0 : item.text) !== null && _a !== void 0 ? _a : '' }, children === null || children === void 0 ? void 0 : children.map((child) => {
            return isHaveChildren(child) ? getSubMenuHTML(child) : getMenuItemHTML(child);
        })));
    };
    // 获取每项菜单的HTML
    const getMenuItemHTML = (item) => {
        var _a, _b;
        if (((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.type) === 'subpage') {
            return;
        }
        return (React.createElement(Item, { key: `${item.key}`, icon: item.icon }, (_b = item === null || item === void 0 ? void 0 : item.text) !== null && _b !== void 0 ? _b : ''));
    };
    const getMenuHTML = (data) => {
        if (!data || data.length === 0) {
            return null;
        }
        return (React.createElement(Menu, Object.assign({ mode: "inline", theme: "dark" }, otherProps), data.map((item) => {
            return isHaveChildren(item) ? getSubMenuHTML(item) : getMenuItemHTML(item);
        })));
    };
    return React.createElement("div", { className: `${prefixCls}-navigation` }, getMenuHTML(data));
};
export default Navigation;
